// Game configuration constants - tweak these to balance the game

export const GAME_CONFIG = {
  // Starting values
  STARTING_MONEY: 10000,
  STARTING_REPUTATION: 3,
  
  // Time settings
  SECONDS_PER_DAY: 60, // Real seconds per in-game day
  DAYS_PER_WEEK: 7,
  WEEKS_PER_MONTH: 4,
  
  // Court costs
  COURT_OUTDOOR_COST: 5000,
  COURT_INDOOR_COST: 12000,
  COURT_MAINTENANCE_WEEKLY: 50,
  COURT_INDOOR_MAINTENANCE_WEEKLY: 100,
  
  // Pricing
  DEFAULT_PRICE_PER_HOUR: 20,
  PEAK_HOUR_MULTIPLIER: 1.5,
  PEAK_HOURS: [18, 19, 20, 21], // 6pm - 10pm
  
  // Customers
  BASE_OCCUPANCY: 0.4, // 40% base occupancy
  REPUTATION_OCCUPANCY_BONUS: 0.1, // +10% per star above 3
  PRICE_SENSITIVITY: 0.02, // -2% occupancy per € above 20
  
  // Grid
  GRID_WIDTH: 20,
  GRID_HEIGHT: 15,
  TILE_SIZE: 64,
  COURT_WIDTH: 3, // tiles
  COURT_HEIGHT: 2, // tiles
  
  // Operating hours
  OPERATING_HOURS: 14, // 8am to 10pm = 14 hours
} as const

export type GameConfigType = typeof GAME_CONFIG
